<template>
  <div class="flex-column pb-1" style="width: 47%" @click="(e) => $emit('click', e)">
    <img :src="item.image_url" style="width: 100%"/>
    <div class="mt-n1 text-center" style="font-size: 10px;">
      {{ item.brand_name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RewardsCatalogItem',

  props: ['item'],
}
</script>
